import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './Intro.scss'

const Intro = ({ image, line1, line2, line3, isVisible }) => {
  return (
    <CSSTransitionGroup
      transitionName='in_intro'
      transitionEnterTimeout={1700}
      transitionLeaveTimeout={1500}
    >
      {isVisible && <div className='in_scene in_intro'>
        <div id='in_intro__doors' className='in_intro__doors' key='intro'>
          <div className='in_intro__door-wrap in_intro__door-wrap_left'>
            <div className='in_intro__door in_intro__door_left' style={{ backgroundImage: `url(${image})` }} />
          </div>
          <div className='in_intro__door-wrap in_intro__door-wrap_right'>
            <div className='in_intro__door in_intro__door_right' style={{ backgroundImage: `url(${image})` }} />
          </div>
        </div>
        <div id='in_intro__content' className='in_intro__content'>
          <span className='in_intro__content-line in_intro__content-line_1'>{line1}</span>
          <span className='in_intro__content-line in_intro__content-line_2'>{line2}</span>
          <span className='in_intro__content-line in_intro__content-line_3'>{line3}</span>
        </div>
      </div>}
    </CSSTransitionGroup>
  )
}

Intro.propTypes = {
  image: PropTypes.string,
  line1: PropTypes.string,
  line2: PropTypes.string,
  line3: PropTypes.string,
  isVisible: PropTypes.bool
}

export default Intro



// WEBPACK FOOTER //
// ./src/templates/insta/components/scenes/Intro.js